// The Total Rewards row's two required fields (VP+ LTI): the approved amount and the wording.
import { Field, Input, Stack, TextArea } from "@/mc";
import { PKG_FIELD_LABELS, PKG_RULES } from "./labels";

export interface TotalRewardsValue { amount: string; wording: string }

export const totalRewardsComplete = (value: TotalRewardsValue): boolean => value.amount.trim() !== "" && value.wording.trim() !== "";

export interface TotalRewardsFormProps {
  value: TotalRewardsValue;
  onChange: (value: TotalRewardsValue) => void;
}

export function TotalRewardsForm({ value, onChange }: TotalRewardsFormProps) {
  return (
    <Stack gap={8} className="mc-pkg-tr">
      <p className="mc-hint">{PKG_RULES.vpLti}</p>
      <Field label={PKG_FIELD_LABELS.approvedAmount} required>
        <Input inputMode="decimal" value={value.amount} onChange={(event) => onChange({ ...value, amount: event.target.value })}  />
      </Field>
      <Field label={PKG_FIELD_LABELS.wording} required>
        <TextArea rows={2} value={value.wording} onChange={(event) => onChange({ ...value, wording: event.target.value })}  />
      </Field>
    </Stack>
  );
}
